import axios from 'axios';
import md5 from 'md5';
import Qs from 'qs';
import cookie from '../cookie';
import platform from '../platform';
import conf from './config';
import Vue from 'vue';
import { versionCompare } from '../common';

let loadingQueue = 0; // 请求计数

const dsBridge = require('dsbridge');

const vm = new Vue();

import sdk from '../sdk';
import { trackClick } from '../track';

let userInfo = {};
const checkLogin = () => {
	if (sdk) {
		userInfo = sdk.getUserInfo();
		return !!(userInfo.accessToken || userInfo.tourist_token);
	}
};

const {
	location: { pathname },
} = window;
const inValidPathName = ['/privacy_protocol', '/agreement', '/third-sdk-list'];

if (!inValidPathName.includes(pathname)) {
	checkLogin();
}

axios.defaults.headers.common['X-Referer-Url'] = encodeURIComponent(window.location.href);
// http请求拦截器
axios.interceptors.request.use(
	(config) => {
		if (!config.header) {
			config.header = {};
		}

		const cookies = 'Cookie' in config.header ? cookie.parse(config.header.Cookie) : {};
		config.header = Object.assign({}, config.header, {
			'content-type': config.header['content-type'] || 'application/x-www-form-urlencoded',
			Cookie: cookie.genarator(Object.assign({}, cookies)),
		});
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);

// http响应拦截器
axios.interceptors.response.use(
	(config) => {
		return config;
	},
	(err) => {
		return Promise.reject(err.response);
	}
);

let keySort = (k1, k2) => {
	let c1 = k1 && k1.charAt(0) ? k1.charAt(0).charCodeAt() : 0;
	let c2 = k2 && k2.charAt(0) ? k2.charAt(0).charCodeAt() : 0;
	if (!c1 && !c2) {
		return 0;
	} else if (c1 == c2) {
		return keySort(k1.substring(1), k2.substring(1));
	} else {
		return c1 - c2;
	}
};

let networkType = '';

try {
	const {
		navigator: {
			connection: { type, effectiveType },
		},
	} = window;

	networkType = effectiveType || type;
} catch (e) {
	console.log(e);
}
/*
 **
 ** @params url——请求地址（必填），paramsData——请求参数（非必填）
 ** @params res——服务器返回结果
 */
//  application/x-www-form-urlencoded
const ajax = (
	method,
	url,
	paramsData = {},
	config,
	returnFullData,
	headers = {
		'Content-Type': 'application/x-www-form-urlencoded',
		'client-v': userInfo['client-v'] || '',
		'device-id': userInfo.sa_device_id || '',
		'platform-model': userInfo['platform-model'],
		'network-type': networkType,
	}
) => {
	config = Object.assign({ loading: true, showToast: true }, config || {});
	if (!url || typeof url !== 'string') {
		throw new Error('必须传入字符串类型的url地址');
	}

	const formData = {
		url: '/api' + url,
		method,
		// 设置请求头为application/x-www-form-urlencoded
		headers,
		// 将序列化参数转换为字符串，使用这种方法需要先引入qs，也可以直接用JSON.stringify()进行转换
		paramsSerializer(params) {
			return Qs.stringify(Object.assign({}, params));
		},
		timeout: 15000,
		// 设置跨域请求为true，如果是cros同源请求的话，则可以不用加此项
		withCredentials: true,
	};

	paramsData = Object.assign(
		{},
		{
			access_token: userInfo.accessToken || paramsData.access_token,
			visitor_token: userInfo.visitor_token || '',
			tourist_token: userInfo.tourist_token || '',
			platform: userInfo.platform,
			platform_brand: userInfo['platform-brand'] || '',
			client_v: userInfo['client-v'],
			device_id: userInfo.sa_device_id,
			utm_source: userInfo['utm-source'],
			request_source: 'h5',
			app_name: userInfo['app-name'] || 'kuaiyin',
			app_v: userInfo['app-v'],
		},
		paramsData
	);

	if (method === 'GET') {
		formData.params = paramsData;
	} else {
		let k = 0;
		paramsData.proj = conf.proj.reduce((r, i) => {
			return (typeof r == 'string' ? r : String.fromCharCode(r - k++)) + String.fromCharCode(i - k++);
		});
		const ts = Math.floor(new Date().getTime() / 1000);

		if (
			userInfo['client-v'] &&
			versionCompare(userInfo['client-v'], '2.8.0') != -1 &&
			versionCompare(userInfo['client-v'], '2.10.4') != 0
		) {
			paramsData.t = ts;
		} else {
			paramsData.sig_ts = ts;
		}
		let keys = Object.keys(paramsData);
		keys.sort(keySort);
		let data = {},
			md5s = [];
		keys.map((k) => {
			if (paramsData[k] !== null && paramsData[k] !== undefined) {
				data[k] = paramsData[k];
				let v = data[k];
				if (typeof v == 'object') {
					v = JSON.stringify(v);
				}
				v = encodeURIComponent(v);
				md5s.push(`${k}=${v}`);
			}
		});

		if (
			userInfo['client-v'] &&
			versionCompare(userInfo['client-v'], '2.8.0') != -1 &&
			versionCompare(userInfo['client-v'], '2.10.4') != 0
		) {
			const sign = sdk.getSignature(decodeURIComponent(md5s.join('&')));
			data.s = sign;
			if (!data.s) {
				let haveSignMethod = '';
				if (platform.platform === 'ios') {
					haveSignMethod = window.dsBridge && window.dsBridge.hasNativeMethod('signContent');
				} else if (platform.platform === 'android') {
					haveSignMethod = window.bridge && !!window.bridge.signContent;
				}
			}
		} else {
			k = 0;
			let sig = conf.sig1.reduce((r, i) => {
				return (typeof r == 'string' ? r : String.fromCharCode(r - k++)) + String.fromCharCode(i - k++);
			});
			data.sig = md5(sig + '&' + md5s.join('&'));
		}

		formData.data = Qs.stringify(data);
	}
	if (config.loading && !paramsData.isNeedHideLoading && loadingQueue == 0) {
		vm.$bus.emit('loading', { show: true });
		loadingQueue = loadingQueue + 1;
	}
	// 使用Promise方法异步处理请求
	return new Promise((resolve, reject) => {
		axios(formData)
			.then((res) => {
				loadingQueue = loadingQueue - 1;
				if (config.loading && !paramsData.isNeedHideLoading && loadingQueue == 0) {
					vm.$bus.emit('loading', { show: false });
				}
				const { data } = res;

				if (+data.code === 0 || +data.code === 2000 || +data.code === 20000) {
					if (data.message) {
						vm.$toast({
							message: data.message,
						});
					}
					resolve(returnFullData ? data : data.data);
					return;
				}

				if (+data.code === 10001) {
					toLogin();
					reject(data);
					return;
				} else if (+data.code === 10005 || +data.code === 10035 || +data.code === 10037) {
					if (platform.platform == 'ios') {
						dsBridge.call('refreshToken', null, () => {});
					} else if (platform.platform == 'android') {
						if (window.bridge) {
							try {
								// alert('叫APP refreshToken');
								console.log('call native refreshToken');
								window.bridge.refreshToken();
							} catch (e) {
								console.log(e);
								// alert('叫APP refreshToken 失败' + e);
							}
						}
					}
					return;
				} else if (+data.code === 10021) {
					reject(data);
				} else if (+data.code === 10025) {
					reject(data);
				}

				if (data.action === 'toast') {
					if (config.showToast && data.message) {
						// 后台报错，但并不需要前端 toast 的接口
						if (url != '/task/get_timing_red_packs' && url != '/task/open_timing_red_pack' && url != '/config/video_window') {
							vm.$toast({
								message: data.message,
							});
						}
					}
				} else if (data.action === 'redirect') {
					if (data.message) {
						vm.$toast({
							message: data.message,
						});
					}
					setTimeout(
						() => {
							location.href = data.url;
						},
						data.message ? 1400 : 1
					);
					return;
				} else if (data.action === 'replace') {
					if (data.message) {
						vm.$toast({
							message: data.message,
						});
					}
					setTimeout(
						() => {
							if (window.router && window.router.replace) {
								window.router.replace({
									name: data.data.page_name,
									query: data.data.query,
								});
							} else {
								location.href = data.url;
							}
						},
						data.message ? 1400 : 1
					);
					return;
				}

				reject(data);
			})
			.catch((e) => {
				loadingQueue = loadingQueue - 1;
				// 报错处理
				// 404 500 错误
				// 服务器异常，请稍后再试
				if (url != '/config/video_window') {
					vm.$toast({
						message: '服务器异常，请稍后再试',
					});
					trackClick({ page_title: '服务器异常', element_name: url });
				} else {
					reject(e);
				}
				if (e && e.message.indexOf('timeout') != -1) {
					trackClick({ page_title: '请求超时', element_name: url, remarks: userInfo.uid });
				}

				if (config.loading && !paramsData.isNeedHideLoading && loadingQueue == 0) {
					vm.$bus.emit('loading', { show: false });
				}
			});
	});
};

const get = (url, data, config, returnFullData) => {
	return ajax('GET', url, data || {}, config, returnFullData);
};

const post = (url, data, config, returnFullData) => {
	return ajax('POST', url, data, config, returnFullData);
};

const postj = (url, data, config, returnFullData) => {
	return ajax('POST', url, data, config, returnFullData, {
		'Content-Type': 'application/json',
	});
};

const upload = (url, data, config, returnFullData) => {
	return ajax('POST', url, data, config, returnFullData, {
		'Content-Type': 'application/json',
	});
};

function toLogin() {
	const appName = userInfo['app-name'] || 'kuaiyin';

	try {
		const JSONStr = {
			url: `${appName}://login`,
		};
		sdk.openPageWithJSON(JSON.stringify(JSONStr));
	} catch (e) {
		console.log(e);
	}
}
// eslint-disable-next-line no-unused-vars
function refreshToken() {
	return post('/passport/get_access_token_by_refresh_token', { refresh_token: userInfo.refreshToken });
}
export default {
	get,
	post,
	postj,
	upload,
	checkLogin,
};



// WEBPACK FOOTER //
// ./src/lib/request/index.js